import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20gaming%20background%20with%20abstract%20geometric%20shapes%20and%20energy%20waves%20in%20dark%20space%2C%20neon%20orange%20and%20warm%20amber%20accents%2C%20futuristic%20gaming%20atmosphere%2C%20sleek%20modern%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20dark%20background%20with%20vibrant%20light%20streaks%20and%20particles&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="galagame 游戏平台背景"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-background-50"></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 pt-20 pb-10">
        <div className="flex flex-col items-center text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-6 animate-fade-in">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
            <span className="text-xs text-primary-400 font-medium">2025夏日狂欢节火热进行中</span>
          </div>

          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground-50 leading-tight max-w-4xl tracking-tight animate-fade-in-up">
            探索无限游戏世界
            <br />
            <span className="text-primary-500">尽在 galagame</span>
          </h1>

          <p className="mt-6 text-base md:text-lg text-foreground-400 max-w-2xl leading-relaxed animate-fade-in-up animation-delay-200">
            galagame 是你不容错过的游戏平台，提供丰富的游戏内容、极致的游戏体验与高额奖励。
            立即加入 galagame，享受专属福利与实时竞技乐趣。
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 mt-8 animate-fade-in-up animation-delay-300">
            <Link
              to="/category"
              className="px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer transform hover:scale-105"
            >
              探索游戏
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 text-sm font-semibold text-foreground-200 border border-background-300 hover:border-primary-500 hover:text-primary-500 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 md:gap-10 mt-14 animate-fade-in-up animation-delay-500">
            {[
              { value: '1200万+', label: '注册玩家' },
              { value: '500+', label: '精品游戏' },
              { value: '98%', label: '好评率' },
              { value: '7x24', label: '客服支持' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500">
                  {stat.value}
                </div>
                <div className="mt-1 text-xs md:text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}